module.exports = __webpack_public_path__ + "static/media/preview_profile.8c0f81a2.svg";